import React from "react";
import { colors, fonts, space, radius } from "../theme";

// Shown on the Waiter / Kitchen screens for a staff account tied to an employee.
export default function ClockBanner({ clock, blocked, dark = true }) {
  if (!clock || !clock.enforced) return null;
  if (blocked) {
    return (
      <div role="status" data-testid="clock-banner" style={{ width: "100%", maxWidth: 900, boxSizing: "border-box", background: "#7c2d12", color: "#fed7aa", borderRadius: radius.sm, padding: space[3], marginBottom: space[3], fontFamily: fonts.body, fontSize: 14 }}>
        <strong>You're clocked out. View only.</strong> Clock in to take orders and update tickets.{" "}
        <a href={clock.clock_url} onClick={(e) => { e.preventDefault(); window.dispatchEvent(new Event("open-clock")); }} style={{ color: "#fff", fontWeight: 600 }}>Clock in</a>
      </div>
    );
  }
  return (
    <div data-testid="clock-banner" style={{ fontFamily: fonts.body, fontSize: 12, color: dark ? colors.textMuted : colors.textSecondary, marginBottom: space[2] }}>
      Clocked in since {clock.since}
    </div>
  );
}
